<template>

    <div id="properties-delete" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
        <div class="modal-dialog modal-sm modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title mb-2" id="exampleModalCenterTitle">Sei sicuro di voler eliminare questo immobile?</h5>
                    <button type="button" class="btn btn-xs btn-icon btn-ghost-secondary" data-dismiss="modal" aria-label="Close">
                        <i class="tio-clear tio-lg"></i>
                    </button>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-white" data-dismiss="modal">Chiudi</button>
                    <button type="button" class="btn btn-primary" @click="sendDeleteEvent">Elimina</button>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {

    props: ['property_id'],

    name: 'delete-property',

    methods: {
        sendDeleteEvent() {
            this.$emit('delete-property',this.property_id);
        }
    }
}
</script>
